import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as _markerClusterer from '@googlemaps/markerclusterer';

(globalThis as any).markerClusterer = _markerClusterer;

import * as Sentry from '@sentry/angular';

import { EnvironmentConfig } from '@environments/environment';
import { AppModule } from './app/app.module';

if (EnvironmentConfig.productionMode) {
  enableProdMode();
}

if (EnvironmentConfig.PortalSettings.monitoringEnabled) {
  Sentry.init({
    dsn: 'https://a2ddfa1cdfa24af1a719428b3ba1770a@o4504803470802944.ingest.sentry.io/4504803480633344',
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 1.0,
    sendDefaultPii: false,
    environment: 'scitis-portal-prod',
    release: 'sprint-4-0-9-test'
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
.catch(err => console.error(err));
